<ws-modal-wrapper headerLabel="Configure Fee Escalator"
                  [disableSave]="savingFeeEscalator"
                  [disableCancel]="savingFeeEscalator"
                  acceptLabel="OK"
                  (save)="save()"
                  (cancel)="cancel()">
    <div>
        <div class="row mt-3">
            Apply Fixed Fee Escalator to:
        </div>
        <div class="row ms-3 mb-3">
            @for (service of services; track service; let i = $index) {
                <div class="col-md-4">
                    <label class="checkbox">
                        <input type="checkbox"
                               [ngModel]="serviceTypeSelected(service.id)"
                               (ngModelChange)="checkedServiceType(service.id, $event)"
                               [attr.data-qa]="'contract-terms-configure-fee-escalator-service-' + i" />
                        {{ service.fullDisplayName || service.name }}
                    </label>
                </div>
            }
        </div>
        <div class="row">
            <label>
                Fee Escalator:
                <input type="text"
                       [(ngModel)]="newFeeEscalator"
                       class="form-control d-inline-block"
                       currencyMask
                       [options]="{ allowNegative: false, precision: 2, prefix: '', suffix: '%' }"
                       style="width:5em;"
                       data-qa="contract-terms-configure-fee-escalator-value" />
            </label>
        </div>
    </div>
</ws-modal-wrapper>
